import * as types from '../constants/payments';
import api from '../api';

export const fetchPaymentsHistoryStart = () => {
  return {
    type: types.FETCH_PAYMENTS_HISTORY_START
  };
};

export const fetchPaymentsHistorySuccess = (payload) => {
  return {
    type: types.FETCH_PAYMENTS_HISTORY_SUCCESS,
    payload
  };
};

export const fetchPaymentsHistoryFailure = (err) => {
  return {
    type: types.FETCH_PAYMENTS_HISTORY_FAILURE,
    err
  };
};

export const fetchPaymentsHistory = (payload, cb) => (dispatch) => {
  const {
    dt1,
    dt2,
    timeZone,
    aff
  } = payload;
  dispatch(fetchPaymentsHistoryStart());

  api.get(`api.php?cmd=paymentsHistory&dt1=${dt1}&dt2=${dt2}&timeZone=${timeZone}&aff=${aff}`)
    .then(({ data }) => {
      dispatch(fetchPaymentsHistorySuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchPaymentsHistoryFailure(err))
    });
};

export const fetchPaymentsDetailsStart = () => {
  return {
    type: types.FETCH_PAYMENTS_DETAILS_START
  };
};

export const fetchPaymentsDetailsSuccess = (payload) => {
  return {
    type: types.FETCH_PAYMENTS_DETAILS_SUCCESS,
    payload
  };
};

export const fetchPaymentsDetailsFailure = (err) => {
  return {
    type: types.FETCH_PAYMENTS_DETAILS_FAILURE,
    err
  };
};

export const fetchPaymentsDetails = (cb) => (dispatch) => {
  dispatch(fetchPaymentsDetailsStart());

  api.get(`api.php?cmd=paymentsDetails`)
    .then(({ data }) => {
      dispatch(fetchPaymentsDetailsSuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchPaymentsDetailsFailure(err))
    });
};

export const setPaymentDetailsStart = () => {
  return {
    type: types.SET_PAYMENTS_DETAILS_START
  };
};

export const setPaymentDetailsSuccess = (payload) => {
  return {
    type: types.SET_PAYMENTS_DETAILS_SUCCESS,
    payload
  };
};

export const setPaymentDetailsFailure = (err) => {
  return {
    type: types.SET_PAYMENTS_DETAILS_FAILURE,
    err
  };
};

export const setPaymentDetails = (payload, cb) => (dispatch) => {
  dispatch(setPaymentDetailsStart());

  api.post(`api.php?cmd=setPaymentDetails`, payload)
    .then(({ data }) => {
      dispatch(setPaymentDetailsSuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(setPaymentDetailsFailure(err))
    });
};
